/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.communication.defs'

export { $nsid }

type TemplateView = {
  $type?: 'tools.ozone.communication.defs#templateView'
  id: string

  /**
   * Name of the template.
   */
  name: string

  /**
   * Content of the template, can contain markdown and variable placeholders.
   */
  subject?: string

  /**
   * Subject of the message, used in emails.
   */
  contentMarkdown: string
  disabled: boolean

  /**
   * Message language.
   */
  lang?: l.LanguageString

  /**
   * DID of the user who last updated the template.
   */
  lastUpdatedBy: l.DidString
  createdAt: l.DatetimeString
  updatedAt: l.DatetimeString
}

export type { TemplateView }

const templateView = /*#__PURE__*/ l.typedObject<TemplateView>(
  $nsid,
  'templateView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.string(),
    name: /*#__PURE__*/ l.string(),
    subject: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    contentMarkdown: /*#__PURE__*/ l.string(),
    disabled: /*#__PURE__*/ l.boolean(),
    lang: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'language' }),
    ),
    lastUpdatedBy: /*#__PURE__*/ l.string({ format: 'did' }),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { templateView }
